import { Button, Space } from '@sravni/react-design-system';
import { Heading, Link } from '@sravni/react-design-system/lib/Typography';
import React from 'react';

import { PropagationInterceptor } from 'shared/ui/PropagationInterceptor';

import type { IOfferNoteData } from 'entities/offerNote';

import type { INoteProps } from '../../../shared/ui/Note/Note';

// название экшена должно совпадать экшеном из IMainNoteData
interface IButtonActions {
  [action: string]: () => void;
}

export function offerNoteDataToView(data: IOfferNoteData | null, buttonActions?: IButtonActions): INoteProps | null {
  if (!data) return null;

  let description = null;

  if (data.links && data.links.length > 0) {
    description = (
      <>
        {data.description && (
          <Heading
            className="h-fs-14"
            level={5}
          >
            {data.description}
          </Heading>
        )}
        <Space
          size={4}
          wrap
        >
          {data.links.map((link) => (
            <PropagationInterceptor key={link.href}>
              <Space
                align="center"
                size={2}
              >
                {link.title && (
                  <Heading
                    className="h-fs-14"
                    level={5}
                  >
                    {link.title}
                  </Heading>
                )}
                <Heading
                  className="h-fs-14"
                  level={5}
                >
                  <Link href={link.href}>{link.label}</Link>
                </Heading>
              </Space>
            </PropagationInterceptor>
          ))}
        </Space>
      </>
    );
  } else if (data.description) {
    description = (
      <Heading
        className="h-fs-14"
        level={5}
      >
        {data.description}
      </Heading>
    );
  } else {
    description = undefined;
  }

  const button =
    data.button && buttonActions?.[data.button.action] ? (
      <PropagationInterceptor>
        <Button onClick={buttonActions[data.button.action]}>{data.button.label}</Button>
      </PropagationInterceptor>
    ) : undefined;

  return {
    title: data.title,
    description,
    button,
    color: data.color,
  };
}
